import { defineMessages } from 'react-intl';

export default defineMessages({
    vehicles: {
        id: 'policycommon.component.policy-vehicle-info.vehicles',
        defaultMessage: 'Vehicles'
    },
    vehicleInfoPolicy: {
        id: 'policycommon.component.policy-vehicle-info.Policy',
        defaultMessage: 'Policy'
    },
    hideVehicleCoverages: {
        id: 'policycommon.component.policy-vehicle-info.hide vehicle coverages',
        defaultMessage: 'Hide Vehicle Coverages'
    },
    showVehicleCoverages: {
        id: 'policycommon.component.policy-vehicle-info.show vehicle coverages',
        defaultMessage: 'Show Vehicle Coverages'
    },
    coveredDrivers: {
        id: 'policycommon.component.policy-vehicle-info.Covered Drivers',
        defaultMessage: 'Covered Drivers'
    },
    make: {
        id: 'policycommon.component.policy-vehicle-info.make',
        defaultMessage: 'Make'
    },
    model: {
        id: 'policycommon.component.policy-vehicle-info.model',
        defaultMessage: 'Model'
    },
    year: {
        id: 'policycommon.component.policy-vehicle-info.year',
        defaultMessage: 'Year'
    },
    licensePlate: {
        id: 'policycommon.component.policy-vehicle-info.license plate',
        defaultMessage: 'License plate'
    },
    vin: {
        id: 'policycommon.component.policy-vehicle-info.VIN',
        defaultMessage: 'VIN'
    },
    totalPremium: {
        id: 'policycommon.component.policy-vehicle-info.Total Premium',
        defaultMessage: 'Total Premium:'
    },
    name: {
        id: 'policycommon.component.policy-vehicle-info.Name',
        defaultMessage: 'Name'
    },
    license: {
        id: 'policycommon.component.policy-vehicle-info.License',
        defaultMessage: 'License'
    },
    dob: {
        id: 'policycommon.component.policy-vehicle-info.Date of Birth',
        defaultMessage: 'Date of Birth'
    },
    vehicleType: {
        id: 'policycommon.component.policy-vehicle-info.Vehicle Type',
        defaultMessage: 'Vehicle Type'
    },
    liabilitySlip: {
        id: "policycommon.component.policy-vehicle-info.Generate Liability Pink Slip",
        defaultMessage: "Generate Liability Pink Slip"
    },
    documentdownloadErrorHead: {
        id: 'policycommon.component.policy-vehicle-info.documentdownloadErrorHead',
        defaultMessage: 'Download failed'
    },
    documentdownloadErrorMessage: {
        id: 'policycommon.component.policy-vehicle-info.documentdownloadErrorMessage',
        defaultMessage: 'Request cannot be processed at this time.'
    },
    ok: {
        id: 'policycommon.component.policy-vehicle-info.ok',
        defaultMessage: 'OK'
    }


});
